"use strict";
exports.__esModule = true;
exports.TagCheckboxFacet = void 0;
var decorators_1 = require("./../decorators");
var logic_1 = require("./../logic");
exports.TagCheckboxFacet = decorators_1.decorateCheckboxFacet(logic_1.TagFacet);
//# sourceMappingURL=TagFacets.js.map